export default __webpack_public_path__ + "static/media/AdSpace_02.6ff7227e.png";